var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStressindex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z",
    fill: "#EAF4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4376 8.375C11.8575 8.375 11.3011 8.60547 10.8908 9.0157C10.4806 9.42594 10.2501 9.98234 10.2501 10.5625C9.72566 10.6382 9.24649 10.9016 8.90164 11.304C8.55679 11.7063 8.3697 12.2201 8.37513 12.75C8.37063 13.168 8.48598 13.5784 8.7075 13.9329C8.92903 14.2873 9.24747 14.5709 9.62513 14.75V15.875C9.62513 16.3723 9.82267 16.8492 10.1743 17.2008C10.5259 17.5525 11.0028 17.75 11.5001 17.75H12.4376V8.375Z",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#004276"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 8.375C16.1427 8.375 16.6991 8.60547 17.1093 9.0157C17.5195 9.42594 17.75 9.98234 17.75 10.5625C18.2745 10.6382 18.7536 10.9016 19.0985 11.304C19.4433 11.7063 19.6304 12.2201 19.625 12.75C19.6295 13.168 19.5142 13.5784 19.2926 13.9329C19.0711 14.2873 18.7527 14.5709 18.375 14.75V15.875C18.375 16.3723 18.1775 16.8492 17.8258 17.2008C17.4742 17.5525 16.9973 17.75 16.5 17.75H15.5625V8.375Z",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#004276"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressindex);
export default __webpack_public_path__ + "static/media/stress index.45b19fbb84edc989575eb40511dc16d8.svg";
export { ForwardRef as ReactComponent };